import {
  IsArray,
  IsBoolean,
  IsDefined,
  IsEnum,
  IsOptional,
  IsString,
  IsUrl,
  ValidateNested,
} from 'class-validator';
import { Expose, Type } from 'class-transformer';
import { Address, Package, Pickup, Money } from '../dto';
import {
  Country,
  PurposeType,
  LogisticProviderCode,
  LogisticServiceCode,
  OrderStatus,
  PaymentMethod,
  PickupStatus,
} from '../common/enums';
import { ParserError } from '../common/errors';

export class Order {
  constructor(props: Partial<Order>) {
    Object.assign(this, props);
  }

  @Expose()
  @IsString()
  id!: string;

  @Expose()
  @IsString()
  ref!: string;


  @IsOptional()
  @IsString()
  customerId?: string;

  @IsOptional()
  @IsString()
  orderId?: string;

  @Expose()
  @IsOptional()
  @IsString()
  trackingNumber?: string;

  @Expose()
  @IsOptional()
  @IsUrl()
  labelUrl?: string;

  @IsBoolean()
  confirmOrder?: boolean;

  @IsBoolean()
  dropoff!: boolean;

  @IsBoolean()
  @IsDefined()
  isPickup!: boolean;

  @Expose()
  @IsOptional()
  @IsEnum(LogisticProviderCode)
  logisticProvider?: string;

  @Expose()
  @IsOptional()
  @IsEnum(LogisticServiceCode)
  logisticServiceCode?: LogisticServiceCode;

  @Expose({ name: 'toAddress' })
  @IsDefined()
  @Type(() => Address)
  @ValidateNested()
  receiverAddress!: Address;

  @Expose({ name: 'fromAddress' })
  @IsDefined()
  @Type(() => Address)
  @ValidateNested()
  shipperAddress!: Address;

  @IsEnum(Country)
  @IsOptional()
  market?: Country;

  @IsEnum(PurposeType)
  @IsOptional()
  type?: PurposeType;

  @Expose({ name: 'metadata' })
  @IsOptional()
  metaData?: Record<string, unknown>;

  @Expose({ name: 'boxes' })
  @IsArray()
  @Type(() => Package)
  packages: Package[] = [];

  @IsEnum(PaymentMethod)
  @IsOptional()
  paymentMethod?: PaymentMethod;

  @Expose()
  @Type(() => Pickup)
  pickup?: Pickup;

  @IsOptional()
  @IsString()
  pickupDate?: string;

  @IsOptional()
  @IsString()
  pickupMaxTime?: string;

  @IsOptional()
  @IsString()
  pickupMinTime?: string;

  @IsOptional()
  pickupStatus?: PickupStatus;

  @Expose()
  @IsEnum(OrderStatus)
  @IsOptional()
  status?: OrderStatus;

  @Expose()
  @IsOptional()
  totalPackages?: number;

  @Expose()
  totalWeight!: number;

  @Expose()
  createdAt?: Date;

  @Expose()
  shipDatetime?: string;

  @IsOptional()
  @Expose({ name: 'finalTotal' })
  @Type(() => Money)
  totalCharge?: Money;

  errors: ParserError[] = [];
}
